import { LockerMultipleIcon } from './LockerMultipleIcon';

/**
 * author: Austin Andrews
 * id 4A5533A8-402C-45F2-9D7A-A8949C22C33B
 * name locker-multiple
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/locker-multiple.svg
 * tags
 */
export const LockersIcon = LockerMultipleIcon;
export default LockersIcon